import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import MediaContainer from './MediaContainer';
import DetailsContainer from './DetailsContainer';
import FooterContainer from './FooterContainer';
import ShowOffSiteInfo from './ShowOffSiteInfo';

const VehicleCard = ({
	accounts,
	shouldShowCompare,
	enableMediaCarousel,
	incentives,
	isGridLayout,
	isMyCarsSitePropEnabled,
	isTabbedLayout,
	setShowOffSite,
	vehicle,
	loadingDelayed,
	forwardedRef,
	featuredPromotion,
	usePlaceholderImage
}) => {
	const { uuid, link } = vehicle;
	return (
		<li
			ref={forwardedRef}
			key={uuid}
			className={setClassNames([
				'box',
				'box-border',
				'vehicle-card',
				'vehicle-card-detailed',
				isGridLayout ? null : 'vehicle-card-horizontal',
				setShowOffSite && 'vehicle-card-fade position-relative',
				featuredPromotion && 'vehicle-card-featured'
			])}
			data-uuid={uuid}
		>
			{setShowOffSite && (
				<ShowOffSiteInfo handleClick={() => setShowOffSite(true)} />
			)}
			<div
				className={setClassNames([
					'vehicle-card-body',
					'ddc-font-size-small',
					isGridLayout ? null : 'd-sm-flex', // TODO: deprecate
					isGridLayout ? null : 'flex-sm-row' // TODO: deprecate
				])}
			>
				<MediaContainer
					{...{
						enableMediaCarousel,
						isTabbedLayout,
						vehicle,
						loadingDelayed,
						usePlaceholderImage
					}}
					accountPhone={accounts[vehicle.accountId]?.phone}
				/>
				<DetailsContainer
					{...{
						vehicle,
						incentives,
						accounts,
						isTabbedLayout,
						isGridLayout
					}}
				/>
			</div>
			<FooterContainer
				{...{
					isTabbedLayout,
					shouldShowCompare,
					isMyCarsSitePropEnabled,
					uuid,
					link
				}}
			/>
		</li>
	);
};

const WrappedVehicleCard = React.forwardRef((props, ref) => {
	return <VehicleCard {...props} forwardedRef={ref} />;
});

VehicleCard.propTypes = {
	enableMediaCarousel: PropTypes.bool.isRequired,
	isGridLayout: PropTypes.bool.isRequired,
	isMyCarsSitePropEnabled: PropTypes.bool.isRequired,
	isTabbedLayout: PropTypes.bool.isRequired,
	incentives: PropTypes.shape({}).isRequired,
	accounts: PropTypes.shape({}).isRequired,
	vehicle: PropTypes.shape({
		uuid: PropTypes.string,
		link: PropTypes.string,
		accountId: PropTypes.string
	}).isRequired,
	setShowOffSite: PropTypes.func,
	shouldShowCompare: PropTypes.bool.isRequired,
	loadingDelayed: PropTypes.bool.isRequired,
	featuredPromotion: PropTypes.bool,
	forwardedRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) })
	]),
	usePlaceholderImage: PropTypes.bool
};

export default WrappedVehicleCard;
